import { Row, Col } from 'react-bootstrap'
import { app } from '../../../../config'
import { navigateTo } from '../'
import { ROUTE_SUPPORT_RESOURCES, KEY_RESOURCE_ID } from '../../helpers/Paths'
import { useHistory } from 'react-router-dom'
import {
  isAndroid,
  isInApp,
  isiOS,
  openUrlInSafari
} from 'components/common/helpers/Mobile'

// Resource Constants
const resources = {
  terms_of_service: {
    path: {
      external: 'https://www.remble.com/terms-of-use',
      internal: ROUTE_SUPPORT_RESOURCES.replace(
        `:${KEY_RESOURCE_ID}`,
        app.resources.pages.terms_of_service
      )
    }
  },
  privacy_policy: {
    path: {
      external: 'https://www.remble.com/privacy',
      internal: ROUTE_SUPPORT_RESOURCES.replace(
        `:${KEY_RESOURCE_ID}`,
        app.resources.pages.privacy_policy
      )
    }
  }
}

/**
 * Simple Compliance Footer component. Used to display privacy policy and terms of use links
 */
export default function ComplianceFooter({
  setNavbarExpanded,
  navigateWithin = true
}) {
  const history = useHistory()

  const handleClick = (event, key) => {
    const targetPath = resources[key].path.internal

    // If we are navigating within the app, we can use the navigateTo helper
    if (navigateWithin || isInApp()) {
      // Disable default link behavior
      event.preventDefault()
      event.stopPropagation()

      // If we passed a navbar, let's close it
      if (setNavbarExpanded) setNavbarExpanded(false)

      // Navigate to the target path, if we want to navigate within the app
      if (navigateWithin) return navigateTo(targetPath, history)

      // Handle iOS link behavior
      if (isInApp()) openUrlInSafari(targetPath)
    }
  }

  return (
    <div className='compliance-footer'>
      <Row>
        <Col className='text-center mt-3'>
          <a
            href={resources.terms_of_service.path.external}
            className='small-link'
            target='_blank'
            rel='noreferrer'
            onClick={e => handleClick(e, 'terms_of_service')}
          >
            Terms of Service
          </a>
          {' | '}
          <a
            href={resources.privacy_policy.path.external}
            className='small-link'
            target='_blank'
            rel='noreferrer'
            onClick={e => handleClick(e, 'privacy_policy')}
          >
            Privacy Policy
          </a>
        </Col>
      </Row>
      <Row>
        <Col className='text-center'>
          <p className='muted'>
            <small>
              <em>
                v:{app.version.slice(0, 7)}:
                {isiOS() && localStorage.getItem('ios_version_app')}
                {isAndroid() && localStorage.getItem('android_version_app')}
              </em>
            </small>
          </p>
        </Col>
      </Row>
    </div>
  )
}
